import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";
import { useSealedInboxFlag } from "./flag";

/**
 * Ai thấy trang "Tố giác & Góp ý": có `sealedinbox.submit` trong phiên VÀ máy
 * chủ đã bật mục (đặt khoá mã hoá). Mục tắt thì ẩn — bấm vào chỉ gặp lỗi 503.
 */
export function canSendSealed(): boolean {
  return hasPermission(ACTION.SealedInboxSubmit) && useSealedInboxFlag.getState().enabled;
}

/**
 * Ai thấy trang "Hộp thư kín": quyền `sealedinbox.read` chỉ là lớp THÔ (quản
 * trị + giám đốc) — cổng thật là có tên trong danh sách người đọc (Câu 2a).
 * Có quyền mà không có tên thì mục ẩn, không để bấm vào rồi ăn 403.
 */
export function canReadSealed(): boolean {
  const f = useSealedInboxFlag.getState();
  return hasPermission(ACTION.SealedInboxRead) && f.enabled && f.isReader;
}

/** Thêm/gỡ người đọc: quyền thô riêng, máy chủ gác tiếp bằng tên. */
export function canManageSealedReaders(): boolean {
  return hasPermission(ACTION.SealedInboxReadersWrite) && canReadSealed();
}
